import client from '../httpClient';

const schedulesGetGuidanceByGuidanceIdApi = (pathParameter, params) => {
  return client.get(`/guidances/${pathParameter}`, JSON.stringify(params));
};

export default schedulesGetGuidanceByGuidanceIdApi;
